import { useEffect, useState } from "react";
import Slider from "react-slick";
import * as Dialog from "@radix-ui/react-dialog";
// import Zoom from 'react-medium-image-zoom';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'react-medium-image-zoom/dist/styles.css';
// import ImageZoom from "./ImageZoom";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import image_sample_banner from "../../assets/images/sample-banner.png";

function SlickSlider() {
    const [promoData, setPromoData] = useState([]);
    const [open, setOpen] = useState(false);
    // const [activeIndex, setActiveIndex] = useState(0);
    const [selectedImage, setSelectedImage] = useState(null);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        const loadCatalog = async () => {
            try {
                const res = await fetch(`/data-web-compro/json/promo.json?t=` + Date.now());
                const data = await res.json();

                const today = new Date();
                const filtered = data.filter((item) => {
                    const start = new Date(item.start_date);
                    start.setHours(0, 0, 0, 0);
                    const end = new Date(item.end_date);
                    end.setHours(23, 59, 59, 999);
                    return today >= start && today <= end;
                });

                setPromoData(filtered);
            } catch (err) {
                console.error('Error fetching catalog:', err);
            } finally {
                setLoading(false);
            }
        };

        loadCatalog();
    }, []);

    const settings = {
        slidesToShow: 1,
        centerPadding: '200px',
        slidesToScroll: 1,
        centerMode: true,
        speed: 1000,
        dots: true,
        autoplay: true,
        // afterChange: (current) => setActiveIndex(current),
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    centerMode: true,
                    centerPadding: '50px',
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 430,
                settings: {
                    dots: false,
                    arrows: false,
                    centerMode: true,
                    centerPadding: '0',
                    slidesToShow: 1
                }
            }
        ]
    };

    const handleImageClick = (img) => {
        setSelectedImage(img);
        setOpen(true);
    };

    return (
        <div className="w-full slider-home pt-[50px] md:pt-[65px] bg-[#F1F8FF]">
            {loading ? (
                <Slider {...settings}>
                    <div className="animate-pulse"><img src={image_sample_banner} alt='FamilyMart Indonesia' /></div>
                    <div className="animate-pulse"><img src={image_sample_banner} alt='FamilyMart Indonesia' /></div>
                    <div className="animate-pulse"><img src={image_sample_banner} alt='FamilyMart Indonesia' /></div>
                </Slider >
            ) : (
                promoData.length > 1 ? (
                    <Slider {...settings}>
                        {promoData.map((promo, index) => {
                            // if (index > 1) return null;

                            return (
                                // <div key={index} > <img src={promo.image} alt={promo.image} /></div>
                                <div key={index} > <img src={promo.image} alt={promo.image} onClick={() => handleImageClick(promo.image)} /></div>
                            );
                        })}
                    </Slider >
                ) : (<>
                    {promoData.map((promo, index) => {
                        // if (index > 1) return null;

                        return (
                            // <div key={index} > <img src={promo.image} alt={promo.image} /></div>
                            <div className="px-[0] sm:px-[50px] md:px-[70px] lg:px-[150px] xl:px-[250px]" key={index} > <img src={promo.image} alt={promo.image} onClick={() => handleImageClick(promo.image)} /></div>
                        );
                    })}

                </>)
            )}

            {/* Modal Zoom */}
            <Dialog.Root open={open} onOpenChange={setOpen}>
                <Dialog.Portal>
                    <Dialog.Overlay className="fixed inset-0 bg-black/80 z-40" />
                    <Dialog.Content className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 rounded shadow-xl max-w-5xl w-full">
                        <Dialog.Title>
                            <VisuallyHidden>Image Title</VisuallyHidden>
                        </Dialog.Title>
                        <Dialog.Description>
                            <VisuallyHidden>Image Description</VisuallyHidden>
                        </Dialog.Description>
                        {/* Konten Modal */}
                        <img
                            src={selectedImage}
                            alt={`Zoomed`}
                            className="w-full object-contain max-h-screen mx-auto"
                        />
                    </Dialog.Content>
                </Dialog.Portal>
            </Dialog.Root>
        </div >
    );
}

export default SlickSlider;
